import $store from '@/store'

import EventModel from './event.js'
import InstanceModel from './instance.js'
import SettingsModel from './settings.js'
import External from './external.js'


export default {
	list_active_channels() {
		return _.filter(Object.values($store.state.channels), (channel) => { return channel.state == "active"; });
	},
	get_channel(channel) {
		if (typeof(channel) == "object") return channel;
		return this.channel_by_id(channel);
	},
	channel_by_id (channel_id) {
  	return $store.state.channels[channel_id] || this.channel_by_uuid(channel_id);
	},
	channel_by_uuid (channel_uuid) {
		return $store.state.channels_uuid[channel_uuid];
	},
	channel_by_name (channel_name) {
		if (channel_name.includes(":")) channel_name = channel_name.split(":")[0];
		return _.find(Object.values($store.state.channels), (channel) => {
			return channel.name == channel_name;
		});
	},
	not_empty(data) {
		return typeof(data) != "undefined" && data != null;
	},
	title (channel) {
		var ch = this.get_channel(channel);
		if (this.not_empty(ch)) {
    	return ch.title;
    } else {
      return "";
    }
	},
	get_type (channel) {
		var ch = this.get_channel(channel);
		if (this.not_empty(ch)) {
			return ch.type;
		}
		return "";
	},
	is_transcoder(channel) {
		var ch = this.get_channel(channel);
		if (this.not_empty(ch)) {
    	return ch.transcoder == true;
    }
   	return false;
	},
	is_cloudstreamer (channel) {
		if (this.get_type(channel) == "input" && this.is_transcoder(channel)) return true;
    return false;
  },
	is_pull(channel) {
		var ch = this.get_channel(channel);
		if (this.not_empty(ch)) {
			return ch.meta.use_pull;
		}
		return false;
	},
	is_admin(channel) {
		var ch = this.get_channel(channel);
		if (this.not_empty(ch)) {
			return ch.meta.is_admin_channel;
		}
		return false;
	},
	is_mediaconnects(channel) {
		var ch = this.get_channel(channel);
		if (this.not_empty(ch)) {
			return ch.meta.use_mediaconnect == true && !_.isEmpty(ch.meta.mediaconnect_arns);
		}
		return false;
	},
	get_channel_input(channel, event) {
		var ch = this.get_channel(channel);
		if (this.not_empty(ch)) {
			var input_key = "default"; // Tähän inputin nimen haku eventin mukaan
			return {key: input_key, config: _.get(ch, ["configuration", "input", input_key], {})};
		}
		return undefined
	},
	get_alternatives(channel) {
		var ch = this.get_channel(channel);
		var outputs = this.outputs_list(ch);
		if(_.isEmpty(outputs)) return [];
		return _.filter(outputs, (o) => {
			return !_.isEmpty(o.alternative) && o.type == "headend";
		});
	},
	get_alternative_title(alternative, channel) {
		if(_.isObject(alternative)) {
			return alternative.title || alternative.alternative || "";
		} else if (this.not_empty(alternative) && this.not_empty(channel)) {
			var ch = this.get_channel(channel);
			var alternatives = this.get_alternatives(ch);
			var alt = _.find(alternatives, (a) => { return a.alternative == alternative; });
			if(alt) return alt.title || alt.alternative || alternative;
		}
		return alternative || "";
	},
	status (channel, alternative) {
		var ch = this.get_channel(channel);
		if (typeof(ch) == "undefined") return;
		var ret = $store.state.channel_status[ch.uuid + (alternative ? ":"+alternative : ":")];
		if (typeof(ret) == "undefined") {
			return $store.state.channel_status[ch.uuid];
		} else {
			return ret;
		}
	},
	get_channel_status_title(uuid) {
		var channel_uuid = uuid.split(":")[0];
		var alternative = uuid.split(":")[1];
		return this.title(channel_uuid) + (alternative ? " ("+this.get_alternative_title(alternative, channel_uuid)+")" : "");
	},
	mediaconnects_status(channel) {
		var ch = this.get_channel(channel);
		if (!this.not_empty(ch) || ch.meta.use_mediaconnect != true || _.isEmpty(ch.meta.mediaconnect_arns)) return;
		return _.map(ch.meta.mediaconnect_arns.split(","), (arn) => { return {arn: arn, ...$store.state.mediaconnects_status[arn.trim()]}; });
	},
	start_transcoder (channel, success, fail) {
		var ch = this.get_channel(channel);
    $store.dispatch("send_control", {"type": "transcoder", "payload": {"type": "start", "channel": ch.uuid}}).then((msg) => {
			success(msg)
    }).catch((msg) => {
    	fail(msg);
    });
  },
	port_request (channel, alternative, success, fail) {
    var ch = this.get_channel(channel);
    $store.dispatch("send_control", {"type": "router", "payload": {"type": "port_request", "channel": ch.uuid, "alternative": alternative}}).then((msg) => {
      success(msg)
    }).catch((msg) => {
    	fail(msg);
    });
  },
  stop_source (channel, alternative, success, fail) {
  	var ch = this.get_channel(channel);
  	$store.dispatch("send_control", {"type": "router", "payload": {"type": "stop_source", "channel": ch.uuid, "alternative": alternative}}).then((msg) => {
  		success(msg);
  	}).catch((msg) => {
  		fail(msg);
  	});
  },
  stop_channel (channel, alternative, success, fail) {
    var ch = this.get_channel(channel);
    $store.dispatch("send_control", {"type": "router", "payload": {"type": "stop_channel", "channel": ch.uuid, "alternative": alternative}}).then((msg) => {
      success(msg)
    }).catch((msg) => {
    	fail(msg);
    });
  },

  outputs_list (channel) {
    // Get outputs from config and convert list/object type configurations into list
  	let ch = this.get_channel(channel)

  	if (this.not_empty(ch)) {
  		let outputs = _.get(ch, "configuration.output.outputs", [])

  		if (_.isArray(outputs)) return outputs
  		return Object.values(outputs)
  	}

  	return []
  },
  toggle_monitor (channel, alternative) {
  	var ch = this.get_channel(channel);
  	if (!this.not_empty(ch)) return false;
  	var channel_key = ch.uuid + ":" + alternative;
  	var acc = _.cloneDeep($store.state.account);
  	acc.meta.monitor_channel_filter = _.xor(acc.meta.monitor_channel_filter, [channel_key]);
  	$store.dispatch("update_profile", acc);
  	return _.includes(acc.meta.monitor_channel_filter, channel_key);
  },
  is_monitor(channel, alternative) {
  	var ch = this.get_channel(channel);
  	if (!this.not_empty(ch)) return false;
		var channel_key = ch.uuid + ":" + alternative;
		return _.includes($store.state.account.meta.monitor_channel_filter, channel_key);
  },
  headend (channel, alternative) {
  	var ch = this.get_channel(channel);
  	if (this.not_empty(ch)) {
	  	var status = this.status(ch, alternative);
  		if (this.not_empty(status)) {
				var instances = InstanceModel.instances_by_type("headend",false);
				var headend_id = _.get(status, ["headend_instance"], "");
				return _.find(instances, function(instance) {
					if (instance.id == headend_id) return true;
					return false;
				});
  		}
  	}
  	return;
  },
	instance (channel, event) {
		var ch = this.get_channel(channel);
		if (this.not_empty(ch)) {
			if (this.is_transcoder(ch) == true && event && ch.type == "output") {
      	var instance = $store.getters.instance_for_event(event);
      	if (typeof(instance) != "undefined") {
          return instance;
        }
      } else {
	      var instance = $store.getters.instance_for_channel(ch);
  	    if (typeof(instance) != "undefined") {
    	    return instance;
      	}
      }
    }
    return undefined;
	},
	status_all () {
		return $store.state.channel_status;
	},
	event_form (channel) {
		if(!channel.meta.event_form) return undefined;
		return SettingsModel.get_by_name(channel.meta.event_form);
	},
	types () {
		return [
    		{label: "Input", value: "input"},
    		{label: "Output", value: "output"}
    ];
	},
	notifiers () {
		return SettingsModel.list("external_notifier");
	},
	transcoder_sizes () {
		return [
			{header: "CPU Gen 6"},
      {name: "AMD Gen 6 4x", value: "a4x"},
      {name: "AMD Gen 6 8x", value: "a8x"},
      {name: "AMD Gen 6 16x", value: "a16x"},
      {name: "AMD Gen 6 32x", value: "a32x"},
      {name: "AMD Gen 6 48x", value: "a48x"},
      {name: "AMD Gen 6 64x", value: "a64x"},
      {name: "AMD Gen 6 96x", value: "a96x"},
			{divider: true},
			{header: "CPU Gen 7"},
      {name: "AMD Gen 7 4x", value: "7a4x"},
      {name: "AMD Gen 7 8x", value: "7a8x"},
      {name: "AMD Gen 7 16x", value: "7a16x"},
      {name: "AMD Gen 7 32x", value: "7a32x"},
      {name: "AMD Gen 7 48x", value: "7a48x"},
      {name: "AMD Gen 7 64x", value: "7a64x"},
      {name: "AMD Gen 7 96x", value: "7a96x"},
			{divider: true},
			{header: "GPU Gen 6"},
      {name: "GPU Gen 6 4x", value: "g4x"},
      {name: "GPU Gen 6 8x", value: "g8x"},
      {name: "GPU Gen 6 16x", value: "g16x"},
      {name: "GPU Gen 6 32x", value: "g32x"},
      {name: "GPU Gen 6 48x", value: "g48x"},
      {name: "GPU Gen 6 64x", value: "g64x"},
      {name: "GPU Gen 6 96x", value: "g96x"},
      {name: "GPU Gen 6 192x", value: "g192x"},
			{divider: true},
			{header: "GPU Gen 7"},
      {name: "GPU Gen 7 8x", value: "g7.8x"},
      {name: "GPU Gen 7 16x", value: "g7.16x"},
      {name: "GPU Gen 7 32x", value: "g7.32x"},
      {name: "GPU Gen 7 48x", value: "g7.48x"},
      {name: "GPU Gen 7 96x", value: "g7.96x"},
      {name: "GPU Gen 7 192x", value: "g7.192x"},
			{divider: true},
			{header: "GPU Gen 7e (Experimental)"},
      {name: "GPU Gen 7e 8x", value: "g7e.8x"},
      {name: "GPU Gen 7e 16x", value: "g7e.16x"},
      {name: "GPU Gen 7e 32x", value: "g7e.32x"},
      {name: "GPU Gen 7e 48x", value: "g7e.48x"},
      {name: "GPU Gen 7e 96x", value: "g7e.96x"},
      {name: "GPU Gen 7e 192x", value: "g7e.192x"},
			{divider: true},
			{header: "CPU Gen 5 (Old)"},
      {name: "4x", value: "4x"},
      {name: "8x", value: "8x"},
      {name: "16x", value: "10x"},
      {name: "16x", value: "12x"},
      {name: "36x", value: "36x"},
      {name: "48x", value: "48x"},
      {name: "72x", value: "72x"},
			{divider: true},
			{header: "GPU Gen 5 (Old)"},
      {name: "GPU Gen 5 4x", value: "5g4x"},
      {name: "GPU Gen 5 8x", value: "5g8x"},
      {name: "GPU Gen 5 16x", value: "5g16x"},
      {name: "GPU Gen 5 32x", value: "5g32x"},
      {name: "GPU Gen 5 48x", value: "5g48x"},
      {name: "GPU Gen 5 64x", value: "5g64x"},
      {name: "GPU Gen 5 96x", value: "5g96x"},
      {name: "GPU Gen 5 192x", value: "5g192x"},
    ];
	}
}
